export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.copyable.success': '已复制',
  'component.copyable.faild': '复制失败',
};
